export const ALL_ALLOWED_LOCALES =
  'allowedLocales: ["en-US", "de-DE", "nl-NL", "fr-FR", "es-ES", "it-IT"]';

export const MAIN_ALLOWED_LOCALES = 'allowedLocales: ["en-US", "de-DE"]';
